/**
 * Wishlist – Pitstopstore
 * localStorage-based wishlist (no login required)
 */

;(function () {
  'use strict';

  // ─── Storage layer ─────────────────────────────────────────────────────────
  var STORAGE_KEY = 'pitstop_wishlist_v1';

  var WishlistStore = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { return []; }
    },
    save: function (items) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('wishlist:updated', {
        bubbles: true,
        detail: { count: items.length, items: items }
      }));
    },
    add: function (item) {
      var items = this.get();
      if (!items.find(function (i) { return i.id === item.id; })) {
        items.push(item);
        this.save(items);
        return true;
      }
      return false;
    },
    remove: function (id) {
      var items = this.get().filter(function (i) { return i.id !== id; });
      this.save(items);
    },
    toggle: function (item) {
      if (this.has(item.id)) { this.remove(item.id); return false; }
      this.add(item); return true;
    },
    has: function (id) {
      return this.get().some(function (i) { return i.id === id; });
    },
    count: function () { return this.get().length; }
  };

  // expose globally so Liquid/other scripts can access it
  window.WishlistStore = WishlistStore;

  // ─── Header count badge ────────────────────────────────────────────────────
  function updateCountBadge(count) {
    document.querySelectorAll('.wishlist-header-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  document.addEventListener('wishlist:updated', function (e) {
    updateCountBadge(e.detail.count);
  });

  // ─── Heart button state ────────────────────────────────────────────────────
  function setHeartState(btn, active) {
    var activeColor  = btn.dataset.activeColor  || '#E53E3E';
    var inactiveColor = btn.dataset.inactiveColor || 'currentColor';
    var svg = btn.querySelector('svg');
    if (!svg) return;
    if (active) {
      svg.setAttribute('fill', activeColor);
      svg.setAttribute('stroke', activeColor);
    } else {
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', inactiveColor);
    }
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Aus Wunschliste entfernen' : 'Zur Wunschliste hinzufügen');
  }

  function initHearts() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = parseInt(btn.dataset.productId, 10);
      setHeartState(btn, WishlistStore.has(id));
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var item = {
          id:         parseInt(this.dataset.productId, 10),
          handle:     this.dataset.productHandle,
          title:      this.dataset.productTitle,
          price:      parseInt(this.dataset.productPrice, 10),
          image:      this.dataset.productImage,
          variant_id: parseInt(this.dataset.variantId, 10),
          url:        this.dataset.productUrl
        };
        var added = WishlistStore.toggle(item);
        setHeartState(this, added);
      });
    });
  }

  // ─── Wishlist page ─────────────────────────────────────────────────────────
  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || 'CHF {{amount}}';
    return fmt
      .replace('{{amount}}', (cents / 100).toFixed(2))
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', (cents / 100).toFixed(2).replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    var url = (window.routes && window.routes.cartAddUrl) || '/cart/add.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { scrollToTop: false }
      }));
      btn.disabled = false;
    })
    .catch(function () { btn.disabled = false; });
  }

  function renderWishlistPage() {
    var container = document.getElementById('wishlist-items-container');
    if (!container) return;

    var items       = WishlistStore.get();
    var emptyState  = document.getElementById('wishlist-empty-state');
    var filledState = document.getElementById('wishlist-filled-state');

    document.querySelectorAll('.wishlist-item-count').forEach(function (el) {
      el.textContent = items.length;
    });

    if (items.length === 0) {
      if (emptyState)  emptyState.style.display  = '';
      if (filledState) filledState.style.display = 'none';
      return;
    }
    if (emptyState)  emptyState.style.display  = 'none';
    if (filledState) filledState.style.display = '';

    var removeColor      = container.dataset.removeColor      || '#1a1a1a';
    var addCartColor     = container.dataset.addCartColor     || '#1a1a1a';
    var addCartTextColor = container.dataset.addCartTextColor || '#ffffff';

    container.innerHTML = items.map(function (item) {
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" class="wishlist-item__img" loading="lazy">'
        : '<div class="wishlist-item__img wishlist-item__img--placeholder"></div>';
      return [
        '<div class="wishlist-item" data-id="' + item.id + '">',
          '<a href="' + item.url + '" class="wishlist-item__image-wrap">' + imgHtml + '</a>',
          '<div class="wishlist-item__info">',
            '<a href="' + item.url + '" class="wishlist-item__title">' + item.title + '</a>',
            '<p class="wishlist-item__price">' + formatMoney(item.price) + '</p>',
          '</div>',
          '<div class="wishlist-item__actions">',
            '<button class="wishlist-item__add-to-cart" data-variant-id="' + item.variant_id + '" ',
              'style="background:' + addCartColor + ';color:' + addCartTextColor + ';" ',
              'aria-label="In den Warenkorb">',
              '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">',
                '<path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>',
              '</svg>',
            '</button>',
            '<button class="wishlist-item__remove" data-id="' + item.id + '" ',
              'style="background:' + removeColor + ';" ',
              'aria-label="Aus Wunschliste entfernen">',
              '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">',
                '<polyline points="3 6 5 6 21 6"/>',
                '<path d="M19 6l-1 14H6L5 6"/>',
                '<path d="M10 11v6"/>',
                '<path d="M14 11v6"/>',
                '<path d="M9 6V4h6v2"/>',
              '</svg>',
            '</button>',
          '</div>',
        '</div>'
      ].join('');
    }).join('');

    // Bind remove buttons
    container.querySelectorAll('.wishlist-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        WishlistStore.remove(parseInt(this.dataset.id, 10));
        renderWishlistPage();
      });
    });

    // Bind add-to-cart buttons
    container.querySelectorAll('.wishlist-item__add-to-cart').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart(this.dataset.variantId, this);
      });
    });
  }

  function initWishlistPage() {
    if (!document.getElementById('wishlist-items-container')) return;

    renderWishlistPage();
    document.addEventListener('wishlist:updated', renderWishlistPage);

    // "Add all to cart" button
    var addAllBtn = document.getElementById('wishlist-add-all-btn');
    if (!addAllBtn) return;
    addAllBtn.addEventListener('click', function () {
      var items = WishlistStore.get();
      if (!items.length) return;
      this.disabled = true;
      var self = this;
      var cartUrl = (window.routes && window.routes.cartAddUrl) || '/cart/add.js';
      Promise.all(items.map(function (item) {
        return fetch(cartUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.variant_id, quantity: 1 })
        });
      })).then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { scrollToTop: false }
        }));
        self.disabled = false;
      }).catch(function () { self.disabled = false; });
    });
  }

  // ─── Inject base CSS ───────────────────────────────────────────────────────
  (function injectStyles() {
    var style = document.createElement('style');
    style.id = 'wishlist-base-styles';
    style.textContent = [
      /* ensure card hearts are positioned correctly */
      '.product-item{position:relative;}',
      '.product-item__wishlist-btn:hover{transform:scale(1.12);}'
    ].join('');
    document.head.appendChild(style);
  })();

  // ─── Init ──────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    updateCountBadge(WishlistStore.count());
    initHearts();
    initWishlistPage();
  });

})();
